import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import { NavLink } from '@/utils/navigation';

export type AppRouterContext = {
  /* Nav links that may be attached to the current layout and made available to it's child routes */
  // Wait until https://github.com/TanStack/router/issues/1635 is fixed before using this.
  navLinks?: NavLink[];
};

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: Component,
});

function Component() {
  return (
    <div className="flex min-h-svh flex-col">
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
      <Toaster richColors={true} />
    </div>
  );
}
